<template>
	<div class="container">
		<div v-permission="[46]" style="margin-bottom: 10px">
			<el-button size="mini" @click="addBtn">添加类型</el-button>
		</div>
		<el-table :data="dataList" :lazy="true" row-key="id">
			<el-table-column prop="id" label="类型ID"></el-table-column>
			<el-table-column prop="name" label="类型名称"></el-table-column>
			<el-table-column prop="malfunctionIds" label="故障类型">
				
				<template slot-scope="scope">
					<div @click="see(scope.row.id)" v-if="!!scope.row.malfunctionIds && scope.row.malfunctionIds!=''" 

						style="color: #336fff; cursor: pointer;">
						查看
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="isSubsidy" label="千物回收补贴">
				<template slot-scope="scope">
					{{scope.row.isSubsidy==1?'是':'否'}}
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<div>
						<el-button v-permission="[47]" size="mini" @click="editBtn(scope.row)"
							:disabled="scope.row.id===4" style="margin-right: 10px">修改</el-button>
						<el-button v-permission="[48]" size="mini" @click="deleteBtn(scope.row)"
							:disabled="scope.row.id===4" style="margin-right: 10px">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="20"
			layout="prev, pager, next, jumper" :total="pageTotal">
		</el-pagination>
		<el-dialog :title="isEdit ? '修改类型信息' : '添加类型'" :visible.sync="showDialog" width="400px"
			:before-close="handleClose">
			<el-form :model="addData" :rules="rules" ref="form" label-width="100px">
				<el-form-item label="类型名称" prop="name">
					<el-input v-model="addData.name" autocomplete="off" auto-complete="off"
						placeholder="请输入类型名称"></el-input>
				</el-form-item>
				<el-form-item label="故障类型" prop="implementation">
					<el-select v-model="addData.malfunction" multiple style="margin-left: 0px; width: 100%;"
						placeholder="请选择">
						<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="千物回收补贴">
					<el-switch v-model="addData.isSubsidy" :active-value="1" :inactive-value="0"></el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="handleClose">取 消</el-button>
				<el-button size="mini" type="primary" @click="comfirm">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="故障类型" :visible.sync="show2Dialog" :before-close="handleClose2">
			<el-table :data="info" :lazy="true" row-key="id">
				<el-table-column prop="id" label="故障ID"></el-table-column>
				<el-table-column width="300px" prop="name" label="故障类型"></el-table-column>
				<el-table-column prop="amount" label="金额"></el-table-column>
				<el-table-column prop="desc" label="描述"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
	import {
		insertOrUpdateImplementatio,
		deleteImplementatio,
		getImplementationList,
		getMalfunction,
		getMalfunctionInfoByImplementatioId
	} from "@/api/implementation";
	export default {
		name: "modelManage",
		data() {
			return {
				dataList: [],
				info: [],
				options: [],
				isEdit: false,
				showDialog: false,
				show2Dialog: false,
				addData: {
					name: "",
					malfunction: []
				},
				rules: {
					name: [{
						required: true,
						message: "请输入机型名称",
						trigger: "blur",
					}]
				},
				pageTotal: 0,
				currentPage: 1,
			};
		},
		methods: {
			see(id) {
				const params = {
					id: id
				}
				getMalfunctionInfoByImplementatioId(params).then(res => {
					// console.log("res - - - - -", res);
					this.info = res.data.data

					this.show2Dialog = true
				})
			},
			addBtn() {
				this.isEdit = false;
				this.addData = {
					isSubsidy: 0
				};
				this.showDialog = true;
			},
			editBtn(row) {
				console.log("row - - - ", row);
				if (row.id === 4) {
					this.openTip()
					return
				}

				this.isEdit = true;
				this.addData = {
					...row,
					malfunction: row.malfunctionIds ? row.malfunctionIds.split(',').map(Number) : [],
					isSubsidy: row.isSubsidy
				};
				this.showDialog = true;
			},
			openTip() {
				this.$notify.info({
					title: '消息',
					message: "'其他' 为默认履约类型 不可修改、删除"
				});
			},
			deleteBtn(row) {
				if (row.id === 4) {
					this.openTip()
					return
				}

				this.$confirm("此操作将永久删除该机型, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						deleteImplementatio({
								id: row.id,
							})
							.then((res) => {
								const response = res.data;
								if (response.code === "200") {
									this.getListData();
									this.$message({
										type: "success",
										message: "删除成功!",
									});
								}
							})
							.catch((e) => {
								console.log(e);
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			comfirm() {
				console.log("this.addData - - - ", this.addData);
				const malfunction = JSON.parse(JSON.stringify(this.addData.malfunction)) // [2, 1, 3]
				const options = JSON.parse(JSON.stringify(this.options))

				const newArray = options.filter(item => malfunction.includes(item.id));
				console.log("newArray- - - ", newArray);


				let malfunctionIds = ''
				if (!!malfunction && malfunction.length >= 1) {

					malfunctionIds = newArray.map(item => item.id).join(',');
					// malfunctionIds: 1, 2, 3
				}

				// console.log("malfunctionIds - ", malfunctionIds);

				// return


				this.$refs["form"].validate((valid) => {
					if (valid) {
						let fun = insertOrUpdateImplementatio;
						let params = {
					// ...this.addData,
					name: this.addData.name,
					malfunctionIds,
					isSubsidy: this.addData.isSubsidy
				};
				if (this.isEdit) params.id = this.addData.id;
						fun(params).then((res) => {
							const response = res.data;
							console.log(response);
							if (response.code === "200") {
								this.$refs["form"].resetFields();
								this.$message.success(this.isEdit ? "修改成功" : "添加成功");
								this.getListData();
								this.showDialog = false;
							}
						});
					} else {
						return false;
					}
				});
			},
			handleClose() {
				this.$refs["form"].resetFields();
				this.showDialog = false;
			},
			handleClose2() {
				this.show2Dialog = false
			},
			handleCurrentChange(e) {
				this.currentPage = e;
				this.getListData();
			},
			search() {
				this.currentPage = 1;
				this.getListData();
			},
			getListData() {
				getImplementationList({
						pageSize: 20,
						pageNumber: this.currentPage,
					})
					.then((res) => {
						const response = res.data;
						if (response.code === "200") {
							let data = response.data;
							console.log(response, data.list);
							this.dataList = data.list;
							this.pageTotal = data.total
						}
					})
					.catch((e) => {
						console.log(e);
					});
			},
			getMalfunctionList() {
				getMalfunction().then(res => {
					this.options = res.data.data
				})
			}
		},
		created() {
			this.getListData();

			this.getMalfunctionList()
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 32px;
		background-color: rgb(240, 242, 245);
	}

	.dialogWrapper {
		display: flex;
		flex-direction: column;

		/deep/ .el-row {
			margin-bottom: 10px;
			display: flex;
			align-items: center;
		}

		/deep/ .el-select {
			width: 100%;
		}

		/deep/ .el-input-number {
			width: 100%;
		}
	}
</style>